import dayjs from "dayjs"
import tz from "dayjs/plugin/timezone"
import utc from "dayjs/plugin/utc"
import { Toaster } from "sonner"

import { TooltipProvider } from "@/components/ui/tooltip"

import GrowthBookProvider from "./growth-book"
import { TanstackQueryProvider } from "./tanstack-query"
import { ThemeProvider } from "./theme"

dayjs.extend(utc)
dayjs.extend(tz)

export const withProviders = (Component: React.FC) => {
  return () => (
    <TanstackQueryProvider>
      <ThemeProvider defaultTheme="light" storageKey="one-ai-theme">
        <GrowthBookProvider>
          <TooltipProvider delayDuration={300}>
            <Component />
            <Toaster richColors visibleToasts={10} />
          </TooltipProvider>
        </GrowthBookProvider>
      </ThemeProvider>
    </TanstackQueryProvider>
  )
}
